export default __webpack_public_path__ + "static/media/fpa40000.3cdb1bf6.png";